// Wave-completion (award end-of-wave bonus, enter waveEnd) and game-over checks.

import type { CheckGameOver, CheckWaveComplete } from './contracts';
import { computeWaveBonus } from '../scoring/bonus';
import { awardPoints } from '../scoring/scoring';
import { GAME_OVER_T, WAVE_END_T } from '../constants';

export const checkWaveComplete: CheckWaveComplete = (state) => {
  if (state.phase.kind !== 'playing') return state;
  const cleared =
    state.spawnQueue.length === 0 && state.enemyMissiles.length === 0;
  if (!cleared) return state;

  const bonus = computeWaveBonus(state);
  const scored = awardPoints(state, bonus.points);
  // Clear the field so in-flight interceptors/explosions don't bleed into the
  // wave-end/intro screens (and can't intercept the next wave for free).
  return {
    ...scored,
    playerMissiles: [],
    explosions: [],
    pendingKills: [],
    flyingObjects: [],
    flyingSpawnAt: null,
    phase: { kind: 'waveEnd', timer: WAVE_END_T, bonus },
  };
};

export const checkGameOver: CheckGameOver = (state) => {
  // Game over is only decided during active play; this also prevents clobbering
  // a waveEnd transition produced earlier in the same tick.
  if (state.phase.kind !== 'playing') return state;
  const anyCityLeft = state.cities.some((c) => c.alive) || state.reserveCities > 0;
  if (anyCityLeft) return state;
  return { ...state, phase: { kind: 'gameOver', timer: GAME_OVER_T } };
};
